export const useGlobalFunctions = () => {
  const checkTokenValidity = (data) => {
    if (data !== null && typeof data.token !== "undefined") {
      if (data.token === false) {
        localStorage.removeItem(process.env.MIX_USER_SESSION_VARIABLE_NAME);
        this.$notify({
          group: "notification",
          type: "warn",
          title: "Token expired",
          text: "Your token is expired, please sign in again",
        });
        this.$router.push("/auth/login");
      }
    }
  };

  const formatDatetimeToTimeHistory = (unformatted_datetime, use_ago = false) => {
    var time_history = "just now";
    if (unformatted_datetime == null) {
      return time_history;
    }
    var datetime = new Date(unformatted_datetime);
    var seconds = Math.floor((new Date() - datetime) / 1000);
    var interval = seconds;
    if (seconds < 60) {
      return time_history;
    }

    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      time_history = interval + " minutes";
    }

    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      time_history = interval + " hours";
    }

    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      time_history = interval + " days";
    }

    interval = Math.floor(seconds / 604800);
    if (interval >= 1) {
      time_history = interval + " weeks";
    }

    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      time_history = interval + " months";
    }

    interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      time_history = interval + " years";
    }
    if (use_ago) {
      time_history += " ago";
    }
    return time_history;
  };

  const globalFunction_formatDate = (date) => {
    var months = this.Months;
    var formatted_date = new Date(date);
    return months[formatted_date.getMonth()].name + " " + formatted_date.getDate() + ", " + formatted_date.getFullYear().toString();
  };

  const globalFunction_formatDatetime = (date) => {
    var months = this.Months;
    var formatted_date = new Date(date);
    return (
      (months[formatted_date.getMonth()] ? months[formatted_date.getMonth()].name : "") +
      " " +
      formatted_date.getDate() +
      ", " +
      formatted_date.getFullYear() +
      " " +
      formatted_date.getHours() +
      ":" +
      formatted_date.getMinutes()
    );
  };

  const globalFunction_formatNumberToCurrency = (amount, currency = "$", allow_negative = true) => {
    let amount_without_negative = amount;
    if (amount < 0) {
      amount_without_negative *= -1;
      if (allow_negative) {
        currency = "- " + currency;
      }
    }
    return currency + "" + new Intl.NumberFormat("en-us", {}).format(amount_without_negative);
  };

  const globalFunction_handleAxiosError = (error, notify = false) => {
    if (typeof error.response === "undefined") {
      console.error(error);
    } else {
      this.checkTokenValidity(error.response.data.data);
      if (notify) {
        this.$notify({
          group: "notification",
          type: "error",
          title: "Failed",
          text: error.response.data.message,
        });
      }
    }
  };

  const globalFunction_getRoleString = (role) => {
    const roles = [
      { value: "admin", text: "Admin" },
      { value: "user", text: "User" },
    ];
    try {
        let roleValue = roles.filter((element) => element.value === role);
        return roleValue[0].text;
    } catch (e) {
        let roleStrArr = role.split('_');
        for (let i = 0; i < roleStrArr.length; i++) {
            roleStrArr[i] = roleStrArr[i].charAt(0).toUpperCase() + roleStrArr[i].slice(1);
        }
        return roleStrArr.join(" ");
    }
  };

  const globalFunction_formatQuantityAndQtyAssmbld = (qty,qty_assmbld) => {
    let qty_text = "";
    let text = '';
    let qty_assmbld_text = "";
    if(qty) {
      qty = qty.toString().toUpperCase();
      if (qty.includes("CONSULT ASSMBLD")) qty_text = "CONSULT ASSMBLD";
      else if (qty.includes("CONSULT")) qty_text = "CONSULT";
      const qty_number = parseInt(qty.replace(/\D/g, ""));
      if (qty_number >= 1000) qty_text = "1000+";
      else if (qty_number >= 750) qty_text = "750+";
      else if (qty_number >= 500) qty_text = "500+";
      else if (qty_number >= 450) qty_text = "450+";
      else if (qty_number >= 400) qty_text = "400+";
      else if (qty_number >= 350) qty_text = "350+";
      else if (qty_number >= 300) qty_text = "300+";
      else if (qty_number >= 250) qty_text = "250+";
      else if (qty_number >= 200) qty_text = "200+";
      else if (qty_number >= 150) qty_text = "150+";
      else if (qty_number >= 100) qty_text = "100+";
      else if (qty_number >= 75) qty_text = "75+";
      else if (qty_number >= 50) qty_text = "50+";
      else if (qty_number >= 25) qty_text = "25+";
      else if (qty_number >= 20) qty_text = "20+";
      else qty_text = "CONSULT";
      if (qty.includes("ASSMBLD")) qty_text += " REQ. ASMBLY";
    }

    if(qty_assmbld) {
      qty_assmbld = qty_assmbld.toString().toUpperCase();
      if (qty_assmbld.includes("CONSULT ASSMBLD")) qty_assmbld_text = "CONSULT ASSMBLD";
      else if (qty_assmbld.includes("CONSULT")) qty_assmbld_text = "CONSULT";
      const qty_number = parseInt(qty_assmbld.replace(/\D/g, ""));
      if (qty_number >= 1000) qty_assmbld_text = "1000+";
      else if (qty_number >= 750) qty_assmbld_text = "750+";
      else if (qty_number >= 500) qty_assmbld_text = "500+";
      else if (qty_number >= 450) qty_assmbld_text = "450+";
      else if (qty_number >= 400) qty_assmbld_text = "400+";
      else if (qty_number >= 350) qty_assmbld_text = "350+";
      else if (qty_number >= 300) qty_assmbld_text = "300+";
      else if (qty_number >= 250) qty_assmbld_text = "250+";
      else if (qty_number >= 200) qty_assmbld_text = "200+";
      else if (qty_number >= 150) qty_assmbld_text = "150+";
      else if (qty_number >= 100) qty_assmbld_text = "100+";
      else if (qty_number >= 75) qty_assmbld_text = "75+";
      else if (qty_number >= 50) qty_assmbld_text = "50+";
      else if (qty_number >= 25) qty_assmbld_text = "25+";
      else if (qty_number >= 20) qty_assmbld_text = "20+";
      else qty_assmbld_text = "CONSULT";
      if (qty_assmbld.includes("ASSMBLD")) qty_assmbld_text += " REQ. ASMBLY";
    }
    if(qty_text.includes("CONSULT") && qty_assmbld_text.includes("CONSULT")) {
      text = 'CONSULT';
    }
    else {
      text = qty_text ? qty_text : '';
      text += text && qty_assmbld_text ? ' & '+qty_assmbld_text : qty_assmbld_text;
    }
    return text;
};

  return {
    checkTokenValidity,
    formatDatetimeToTimeHistory,
    globalFunction_formatDate,
    globalFunction_formatDatetime,
    globalFunction_formatNumberToCurrency,
    globalFunction_handleAxiosError,
    globalFunction_getRoleString,
    globalFunction_formatQuantityAndQtyAssmbld
  };
};
